/*
 * Copyright (c) 2017 Datarista, Inc.
 */

import { Map, Record, List } from 'immutable';
import { actionTypes } from '../actions/pricing';

export const PriceBook = new Record(
  {
    id: 0,
    accountId: 0,
    priceBucketType: 'CPS',
    min: 0,
    max: 0,
    cost: 0,
    floor: 0,
  },
  'PriceBook'
);

const InitialSetting = new Record(
  {
    revShareVal: 0,
    pricingEnabledVal: 'true',
  },
  'InitialSetting'
);

const priceBook = new Map({
  maList: new List(),
  crmList: new List(),
  priceBookList: new Map(),
  revShare: 0,
  allSettings: new Map(),
  initialSettings: new InitialSetting(),
});

const initialState = priceBook;

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_PRICEBOOK_SUCCESS: {
      const { crmPrices } = action.priceBook;
      const crmRecords = new List(crmPrices.map(bucket => new PriceBook(bucket)));

      const { maPrices } = action.priceBook;
      const maRecords = new List(maPrices.map(bucket => new PriceBook(bucket)));

      // Adds price to list of pricebooks, for superadmin
      const priceBookMap = new Map({
        maList: maRecords,
        crmList: crmRecords,
        revShare: 0,
      });
      const oldMap = state.get('priceBookList');
      const newMap = oldMap.set(action.accountId, priceBookMap);

      return state.merge({
        maList: maRecords,
        crmList: crmRecords,
        priceBookList: newMap,
      });
    }
    case actionTypes.GET_REV_SHARE: {
      const revShareVal = Number.parseFloat(action.revShare.accountSettingValue);
      const oldPriceList = state.get('priceBookList');
      const oldRevs = oldPriceList.get(action.accountId);
      if (oldRevs !== undefined) {
        const newRevs = oldRevs.set('revShare', revShareVal);
        const newPriceBookList = oldPriceList.set(action.accountId, newRevs);
        return state.merge({
          revShare: revShareVal,
          priceBookList: newPriceBookList,
        });
      }
      return state.merge({
        revShare: revShareVal,
        priceBookList: oldPriceList,
      });
    }
    case actionTypes.UPDATE_PRICE: {
      const pBucket = action.updatedBucket;

      // Updating the information in the pricebook list
      // For superadmin
      const oldPriceList = state.get('priceBookList');
      const oldPriceBook = oldPriceList.get(action.accountId);

      let mergeList = new List();
      let adminMergeList = new List();
      if (pBucket.priceBucketType === 'CPS') {
        mergeList = state.get('crmList');
        adminMergeList = oldPriceBook.get('crmList');
      } else {
        mergeList = state.get('maList');
        adminMergeList = oldPriceBook.get('maList');
      }
      const newList = mergeList.map(bucket => {
        if (bucket.id === pBucket.id) {
          return new PriceBook(pBucket);
        }
        return bucket;
      });
      const newAdminList = adminMergeList.map(bucket => {
        if (bucket.id === pBucket.id) {
          return new PriceBook(pBucket);
        }
        return bucket;
      });

      if (pBucket.priceBucketType === 'CPS') {
        const newPriceBook = oldPriceBook.set('crmList', newAdminList);
        const newPriceList = oldPriceList.set(action.accountId, newPriceBook);
        return state.merge({
          crmList: newList,
          priceBookList: newPriceList,
        });
      }

      const newPriceBook = oldPriceBook.set('maList', newAdminList);
      const newPriceList = oldPriceList.set(action.accountId, newPriceBook);
      return state.merge({
        maList: newList,
        priceBookList: newPriceList,
      });
    }
    case actionTypes.FETCH_ALL_SETTINGS: {
      // This action is also used to retrieve an individual setting,
      // so we handle merges now that we have multiple settings.
      const oldSettings = state.get('allSettings');
      let newSettings = new Map();
      action.settingsInfo.map(setting => {
        newSettings = newSettings.set(setting.accountSettingType, setting);
        return newSettings;
      });
      const mergedAllSettings = new Map([...oldSettings, ...newSettings]);
      const newInitialSettings = new InitialSetting({
        revShareVal: mergedAllSettings.get('REV_SHARE').accountSettingValue,
        pricingEnabledVal: mergedAllSettings.get('PRICING_ENABLED').accountSettingValue,
      });

      return state.merge({ allSettings: mergedAllSettings, initialSettings: newInitialSettings });
    }
    default: {
      return state;
    }
  }
}
